import { type FC, type PropsWithChildren, useMemo } from 'react';

import Text from '@/components/Text';

type Props = {
  title: string;
  description?: string | JSX.Element;
};

const GithubDataSectionWrap: FC<PropsWithChildren<Props>> = ({
  title,
  children,
  description,
}) => {
  const descriptionElement = useMemo(() => {
    if (!description) return null;
    if (typeof description === 'string')
      return (
        <Text variant="body-caption" className="py-2 text-neutral-300">
          {description}
        </Text>
      );
    return description!;
  }, [description]);
  return (
    <div className="flex flex-col divide-y divide-neutral-600 rounded-lg bg-neutral-900 p-4">
      <Text variant="body-small" className="pb-2 text-neutral-100">
        {title}
      </Text>
      {descriptionElement}
      <div className="grid grid-cols-2 gap-2 pt-2">{children}</div>
    </div>
  );
};

export default GithubDataSectionWrap;
